import React from 'react'
import crumbs from '../../images/crumbs.jpg'
import { Article } from '../common/Layout'
import { Button, Card } from '@foodsby/nutrient'
import { Link } from 'react-router-dom'
import { homeRoute } from '../../routes/routes'

const style = {
  img: {
    width: '100%',
  },
}

const NotFound = () => (
  <Article>
    <Card>
      <div className="row center-xs middle-xs">
        <div className="col-xs-12 col-sm-6">
          <img alt="404 Food Not Found" src={crumbs} style={style.img} />
        </div>
        <div className="col-xs-12 col-sm-6 first-xs last-sm">
          <h1 className="title">The page you were looking for was eaten.</h1>
          <p>
            This page is no longer available, or the URL has changed! You can
            head back to the homepage to order.
          </p>
          <Link to={homeRoute.path}>
            <Button>Go home to order</Button>
          </Link>
        </div>
      </div>
    </Card>
  </Article>
)

export default NotFound
